import Decimal from 'decimal.js'
import { GiftCardDetailContract } from 'models'
import { createContext, useContext } from 'react'
export interface PaymentFormModel {
    PaymentID?: string
    giftcard?: GiftCardDetailContract
    paymentSettingID: string
    paymentType: number | undefined
    expectAmount: Decimal
    isManual: boolean
}
interface ISplitPaymentContext {
    isCharging: boolean
    onClickCharging: (payment: PaymentFormModel, index: number) => void
    reducePayment: () => void
    deletePayment: (index: number) => void
    onChangePayment: (payment: PaymentFormModel, index: number) => void
    addPayment: () => void
    paymentCount: number
    paymentForms: PaymentFormModel[]
    remainingAmount: Decimal
    splitEvenly: () => void
    onFinishCharging: (paymentID: string | undefined) => void
    onClickBack: () => void
}

const initialState: ISplitPaymentContext = {} as ISplitPaymentContext
const SplitPaymentContext = createContext(initialState)

export { SplitPaymentContext }

export default function useSplitPaymentContext() {
    const appValue = useContext(SplitPaymentContext)
    return appValue
}
